

























































































































































































































































































































































































import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import {
  ActiveSurveyForm,
  SatisfactionSurveyActiveForm,
  SurveyRequest,
} from "@/api";
import { VForm } from "@/common/vuetify_types";
import { SurveyFormCollection } from "@/common/InspectionDataCollection";
import { dateFormat, hourMinAdder } from "@/common/date_format";
import _ from "lodash";
import { selfData } from "@/common/role_utils";
import {
  maxLenInt,
  noSpace,
  numberOnly,
  requiredSelectWithZero,
  requiredString,
  validateCharacter,
} from "@/tool/validation";
import ConfirmModule from "@/components/confirmationModule/ConfirmationModule.vue";
import moment from "moment";

@Component({
  components: {
    ConfirmModule,
  },
})
export default class SurveyForm extends Vue {
  @Prop() readonly dispatchType!: string;
  @Prop() readonly title!: string;

  @Ref("initialForm") initialForm!: VForm;
  @Ref("form") form!: VForm;

  step = 0;
  self = selfData();
  submitting = false;
  confirmClose = false;
  dischargeDatePicker = false;
  admissionDatePicker = false;
  admissionDate = "";
  dischargeDate = "";
  firstNameInitial = "";
  lastNameInitial = "";
  textRules = [requiredString, noSpace];
  charRules = [validateCharacter];
  selectRules = [requiredSelectWithZero];
  numberRules = [numberOnly];
  phoneRules = [
    requiredString,
    numberOnly,
    noSpace,
    (v: string) => maxLenInt(v, 10),
  ];

  minDate = moment()
    .local()
    .format("YYYY-MM-DD");
  surveyData: SurveyFormCollection[] = [];
  payload: SurveyRequest = {
    survey: {
      companyId: 0,
      formId: 0,
      roomId: 0,
      resident: "",
      phone: "",
      completedBy: "",
    },
    physician: {
      companyId: 0,
      name: "",
    },
    data: [],
  };
  commentError = "";
  feedbackError = "";
  meetError = "";
  ratingError = "";
  completedByOption = ["Family", "Friends", "Patient"];
  completedBy = "";

  async created() {
    await this.$store.dispatch("room/fetchCompanyRooms");
  }

  get companyRooms() {
    return this.$store.getters["room/companyRooms"] || [];
  }

  get questionLists() {
    let form = null;
    let index = 1;
    this.surveyData = [];
    switch (this.dispatchType) {
      case "admission":
        form = this.$store.getters[
          "survey/activeAdmissionForm"
        ] as ActiveSurveyForm;
        this.payload.survey.formId = form.id;
        _.sortBy(form?.questions || [], ["order"], ["desc"]);
        _.forEach(form?.questions || [], question => {
          const data = {
            index: index,
            question: question,
            data: {
              questionId: question.id,
              comment: undefined,
              feedback: undefined,
              ratingScore: 0,
            },
          };
          this.surveyData.push(JSON.parse(JSON.stringify(data)));
          index++;
        });
        break;
      case "discharge":
        form = this.$store.getters[
          "survey/activeDischargeForm"
        ] as ActiveSurveyForm;
        this.payload.survey.formId = form.id;
        _.sortBy(form?.questions || [], ["order"], ["desc"]);
        _.forEach(form?.questions || [], question => {
          const data = {
            index: index,
            question: question,
            data: {
              questionId: question.id,
              comment: undefined,
              feedback: undefined,
              ratingScore: 0,
            },
          };
          this.surveyData.push(JSON.parse(JSON.stringify(data)));
          index++;
        });
        break;
      case "satisfaction":
        form = this.$store.getters[
          "survey/activeSatisfactionForm"
        ] as SatisfactionSurveyActiveForm;
        this.payload.survey.formId = form.id;
        _.sortBy(form?.questions || [], ["order"], ["desc"]);
        _.forEach(form?.questions || [], question => {
          const data = {
            index: index,
            question: question,
            data: {
              questionId: question.id,
              comment: undefined,
              feedback: undefined,
              ratingScore: 0,
            },
          };
          this.surveyData.push(JSON.parse(JSON.stringify(data)));
          index++;
        });
        break;
    }
    return this.surveyData;
  }

  formatDate(date: string) {
    switch (this.dispatchType) {
      case "admission":
        this.payload.survey.admissionDate = dateFormat(date);
        break;
      case "discharge":
        this.payload.survey.dischargeDate = dateFormat(date);
        break;
      case "satisfaction":
        this.payload.survey.admissionDate = dateFormat(date);
        break;
    }
  }

  nextInspection() {
    const valid = this.initialForm.validate();
    if (valid) {
      this.payload.survey.companyId = this.self.companyId;
      this.payload.physician.companyId = this.self.companyId;
      this.payload.survey.completedBy = this.completedBy;
      this.payload.survey.duration = Number(this.payload.survey.duration);
      this.step++;
    }
  }

  clearError() {
    this.commentError = "";
    this.feedbackError = "";
    this.meetError = "";
    this.ratingError = "";
  }

  validate(item: SurveyFormCollection): boolean {
    this.clearError();
    let valid = true;
    if (this.dispatchType !== "satisfaction") {
      if (!item.data.skipRating && !item.data.ratingScore) {
        this.meetError = "Give 1-5 rating or select checkbox for skip.";
        valid = false;
      }
    } else {
      if (item.data.meet == undefined && !item.data.skipRating) {
        this.meetError = "Please select met or not met.";
        valid = false;
      }
    }

    return valid;
  }

  next(item: SurveyFormCollection) {
    const valid = this.validate(item);
    if (valid) this.step++;
  }

  async submit(item: SurveyFormCollection) {
    const valid = this.validate(item);
    if (valid) {
      this.submitting = !this.submitting;
      this.payload.survey.resident =
        this.firstNameInitial.toUpperCase() +
        " " +
        this.lastNameInitial.toUpperCase();
      this.payload.data = [];
      // eslint-disable-next-line
      const satisfactionPayloadData: any[] = [];
      _.forEach(this.surveyData, item => {
        satisfactionPayloadData.push({
          questionId: item.data.questionId,
          comment: item.data.comment,
          meet: item.data.meet,
          skipQuestion: item.data.skipRating,
        });
        if (item?.data.skipRating) item.data.ratingScore = 0;
        this.payload.data.push({
          questionId: item.data.questionId,
          comment: item.data.comment,
          feedback: item.data.feedback,
          ratingScore: item.data.ratingScore,
        });
      });
      const satisfactionPayload = {
        survey: {
          companyId: this.payload.survey.companyId,
          formId: this.payload.survey.formId,
          roomId: this.payload.survey.roomId,
          resident: this.payload.survey.resident,
          physician: this.payload.physician.name,
          completedBy: this.payload.survey.completedBy,
          admissionDate: hourMinAdder(this.admissionDate),
        },
        data: satisfactionPayloadData,
      };
      await this.$store.dispatch("survey/submitSurvey", {
        requestBody: this.payload,
        satisfactionRequestBody: satisfactionPayload,
        dispatchType: this.dispatchType,
      });
      this.submitting = !this.submitting;
      this.step++;
    }
  }

  close() {
    this.$emit("close");
  }

  complete() {
    this.$emit("complete");
  }

  recognize() {
    this.$emit("recognize");
  }
}
